import { SubscriptionTier } from '@heidi/schema/ml-scribe';

/**
 * Auto-queued 50%/80% credit-usage popover tier gate — free, Pro, Clinician
 * Pro. Not Practice / Clinician Pro Plus. The sidebar credit tile shows on
 * every resolved tier once opt-in × `heidi_version` 2; this narrower check is
 * intentional so Practice-plus seats are not auto-nudged.
 *
 * An unresolved tier (null/undefined while `useQueryUserTier` loads) is OUT:
 * the surface waits for an explicit tier rather than flashing for a user who
 * resolves to a Practice-plus tier.
 */
export function isCreditUsageSurfaceTier(
  tier: SubscriptionTier | null | undefined
): boolean {
  return (
    tier === SubscriptionTier.FREE ||
    tier === SubscriptionTier.PRO ||
    tier === SubscriptionTier.CLINICIAN_PRO
  );
}
